import { api_sign_up_for_weekly_digest_path } from '@routes';

import request from './request';

export interface SignUpForWeeklyDigestResponse {
  message: string;
  redirectUri?: string;
  success: boolean;
}

export async function signUpForWeeklyDigest() {
  const resp = await request('post', api_sign_up_for_weekly_digest_path());
  return resp;
}
